import { AppComponent } from "./app.component";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { FeedbackComponent } from "./feedback/feedback.component";
import { FetchDataComponent } from "./fetch-data/fetch-data.component";
import { HomeComponent } from "./home/home.component";
import { ImprintComponent } from "./imprint/imprint.component";
import { LoginComponent } from "./login/login.component";
import { NavMenuComponent } from "./nav-menu/nav-menu.component";
import { ModalComponent } from "./shared/modal/modal.component";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TeamComponent } from "./team/team.component";

@NgModule({
    declarations: [AppComponent],
    imports: [
        TeamComponent,
        FeedbackComponent,
        ImprintComponent,
        ModalComponent,
        NavMenuComponent,
        HomeComponent,
        FetchDataComponent,
        LoginComponent,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule       
    ],
    providers: [       
        provideHttpClient(withInterceptorsFromDi()),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
